import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { PortMyRequestComponent } from './port-my-request.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { PortMyRequestRoutingModule } from './port-my-request-routing.module';
import { GemininotesPopupModule } from '../gemininotes-popup/gemininotes-popup.module';
import { PortConsumptionReportDownloadPopupModule } from '../port-consumption-report-download-popup/port-consumption-report-download-popup.module';
import { PortDeleteConfirmPopupModule } from '../port-delete-confirm-popup/port-delete-confirm-popup.module';

@NgModule({
  declarations: [PortMyRequestComponent],
  imports: [
    CommonModule,
    CustomInputModule,
    FormsModule,
    TitleCasePipe,
    ReactiveFormsModule,
    PcMultiSelectFilterModule,
    ExpansionPanelModule,
    CustomDatePickerModule,
    MaterialModule,
    MatPaginatorModule,
    CustomTimpickerModule,
    MatSortModule,
    PortMyRequestRoutingModule,
    GemininotesPopupModule,
    PortConsumptionReportDownloadPopupModule,
    PortDeleteConfirmPopupModule,
  ],
  exports: [PortMyRequestComponent],
})
export class PortMyRequestModule {}
